import React from "react";
import styled, { keyframes } from "styled-components";

import { jsPDF } from "jspdf"; // Ensure you have jspdf installed

// Styled Components
const Container = styled.div`
  background-color: #0e0e10;
  padding: 2rem;
  font-family: "Roboto Condensed", sans-serif;
  display: flex;
  justify-content: space-evenly;
  @media (max-width: 768px) {
    display: inline;
  }
`;
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const Section = styled.section`
  margin-bottom: 2rem;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #353535;

  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0;
  border-radius: 5px;
  transform: translateY(20px);
  animation: ${fadeIn} 0.6s ease-out forwards;
  animation-delay: ${(props) => props.delay || "0s"};
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

const SectionHeader = styled.h2`
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
  color: #3f51ff;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
  color: #e6e6e6;
`;

const Button = styled.button`
  background: #194bfd;
  background: linear-gradient(
    90deg,
    rgba(25, 75, 253, 1) 0%,
    rgba(173, 19, 251, 1) 100%
  );
  border-radius: 5px;
  transition: all 0.3s ease;
  color: #dee2e6;
  border: none;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  cursor: pointer;
  font-family: "Roboto Condensed", sans-serif;
  &:hover {
    background-color: #5a189a;
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);

    color: #dee2e6;
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0.75rem;
  }
`;

const EnquiryAndDocument = () => {
  const downloadDocument = (type) => {
    const doc = new jsPDF();
    let y = 10;

    // Add website header
    doc.setFontSize(16);
    doc.setTextColor(30, 144, 255);
    doc.text("Passport Assistance Service", 10, y);
    y += 10;

    doc.setFontSize(14);
    doc.setTextColor(0);
    doc.text(`Documents for ${type}`, 10, y);
    y += 10;

    if (type === "Fresh Passport") {
      const freshPassportItems = [
        "1. Voter ID card",
        "2. Aadhaar card/E-Aadhaar",
        "3. PAN card",
        "4. Driving licence",
        "5. Birth certificate",
        "6. Ration card",
        "7. 10th standard marks card",
        "8. 12th standard marks card",
        "9. Bank passbook photo",
        "10. Marriage Certificate (if Married)",
        "11. Passport Size Photo 2 Recently",
        "12. Aadhaar Card, PAN Card Zerox or Original Mother",
        "13. Aadhaar Card, PAN Card Zerox or Original Father",
      ];

      doc.setFontSize(12);
      freshPassportItems.forEach((item) => {
        if (y > 280) {
          doc.addPage();
          y = 10;
        }
        doc.text(item, 10, y);
        y += 10;
      });
    } else if (type === "Re-issue Passport") {
      const reissueItems = [
        "Re-issue Passport Document:",
        "1. Old Passport Front and Back ( Original | Xerox )",
        "2. Aadhaar Card",
        "3. PAN Card",
        "4. Birth Certificate (if Child)",
        "5. Driving Licence",
        "6. Marriage Certificate (if Married )",
        "",
        "Verification Document:",
        "1. Aadhaar Card, PAN Card ( Original | Xerox )",
        "2. 10th Marksheet, 12th Marksheet ( Original | Xerox )",
        "3. Passport Size 2 Photos ( Recently )",
        "4. Mother Aadhaar Card, PAN Card , Father Aadhaar Card, PAN Card | ( Original | Xerox )",
        "5. Any Document like ( TC, Driving licence, Bank passbook ) ( Original | Xerox )",
        "6. Marriage Certificate (if Married )",
      ];

      doc.setFontSize(12);
      reissueItems.forEach((item) => {
        if (y > 280) {
          doc.addPage();
          y = 10;
        }
        doc.text(item, 10, y);
        y += 10;
      });
    }

    // Footer / Inquiry Note
    if (y > 270) {
      doc.addPage();
      y = 10;
    }

    doc.setFontSize(11);
    doc.setTextColor(100);
    doc.text("For any inquiries, please contact us at 8788365413.", 10, y + 10);
    doc.text(
      "We are here to assist you with your passport and Visa needs.",
      10,
      y + 20
    );

    doc.save(`${type}_Documents.pdf`);
  };

  return (
    <>
      <Container>
        <Section>
          <SectionHeader>Fresh Passport Document</SectionHeader>
          <List>
            <ListItem>1. Voter ID card</ListItem>
            <ListItem>2. Aadhaar card/E-Aadhaar</ListItem>
            <ListItem>3. PAN card</ListItem>
            <ListItem>4. Driving licence</ListItem>
            <ListItem>5. Birth certificate</ListItem>
            <ListItem>6. Ration card</ListItem>
            <ListItem>7. 10th standard marks card</ListItem>
            <ListItem>8. 12th standard marks card</ListItem>
            <ListItem>9. Bank passbook photo</ListItem>
            <ListItem>10. Marriage Certificate (if Married )</ListItem>
            <ListItem>11. Passport Size Photo 2 Recently</ListItem>

            <ListItem>
              12. Aadhaar Card, PAN Card Zerox or Original Mother
            </ListItem>
            <ListItem>
              13. Aadhaar Card, PAN Card Zerox or Original Father
            </ListItem>
          </List>

          <Button onClick={() => downloadDocument("Fresh Passport")}>
            Download Fresh Passport Document List
          </Button>
        </Section>

        <Section>
          <SectionHeader>Re-issue Passport Document</SectionHeader>
          <List>
            <ListItem>
              1. Old Passport Front and Back ( Original | Xerox )
            </ListItem>
            <ListItem>2. Aadhaar Card</ListItem>
            <ListItem>3. PAN Card</ListItem>
            <ListItem>4. Birth Certificate (if Child)</ListItem>
            <ListItem>5. Driving Licence</ListItem>
            <ListItem>6. Marriage Certificate (if Married )</ListItem>
          </List>
          <SectionHeader>Verification Document</SectionHeader>
          <List>
            <ListItem>1. Aadhaar Card, PAN Card ( Original | Xerox )</ListItem>
            <ListItem>
              2. 10th Marksheet, 12th Marksheet ( Original | Xerox )
            </ListItem>
            <ListItem>3. Passport Size 2 Photos ( Recently )</ListItem>
            <ListItem>
              4. Mother Aadhaar Card, PAN Card , Father Aadhaar Card, PAN Card |
              ( Original | Xerox )
            </ListItem>
            <ListItem>
              5. Any Document like ( TC,Driving licence,Bank passbook ) (
              Original | Xerox )
            </ListItem>
            <ListItem>6. Marriage Certificate (if Married )</ListItem>
          </List>
          <Button onClick={() => downloadDocument("Re-issue Passport")}>
            Download Re-issue Passport Document List
          </Button>
        </Section>
      </Container>
      <p style={{ textAlign: "center", color: "#e6e6e6" }}>
        For any inquiries, please contact us at <strong>8788365413</strong>. We
        are here to assist you with your passport needs.
      </p>
    </>
  );
};

export default EnquiryAndDocument;
